import { server_connection } from 'config';
import store from 'store';
export const GET_STUDENT = '[STUDENT APP] GET STUDENT';
export const GET_STUDENT_LIST = '[STUDENT APP] GET STUDENT LIST';
export const SAVE_STUDENT = '[STUDENT APP] SAVE STUDENT';
export const DELETE_STUDENT = '[STUDENT APP] DELETE STUDENT';
export const GET_STUDENT_DATA = '[STUDENT APP] GET STUDENT DATA';
export const UPDATE_STUDENT_LOADED = '[STUDENT APP] UPDATE STUDENT LOADED';
export const UPDATE_STUDENT_FORM = '[STUDENT APP] UPDATE STUDENT FORM';
export const GET_RELATED_DATA = '[STUDENT APP] GET RELATED DATA';
export const GET_STUDENT_COURSES = '[STUDENT APP] GET STUDENT COURSES';
export const GET_STUDENT_SCHEDULE = '[STUDENT APP] GET STUDENT SCHEDULE';
export const GET_DAY_EVENTS = '[STUDENT APP] GET DAY EVENTS';
export const TOGGLE_COMPANY = '[STUDENT APP] TOGGLE COMPANY';
export const GET_EDIT_INFO = '[STUDENT APP] GET EDIT INFO';
export const GET_NEXT_UNSCHEDULED_EVENTS = '[STUDENT APP] GET NEXT UNSCHEDULED EVENTS';
export const GET_NEXT_SCHEDULED_EVENT = '[STUDENT APP] GET NEXT SCHEDULED EVENT';
export const GET_NEXT_UNSCHEDULED_EVENT_WIDGET = '[STUDENT APP] GET NEXT UNSCHEDULED EVENT WIDGET';
export const CHECK_DOES_STUDENT_HAVE_COURSES = '[STUDENT APP] CHECK DOES STUDENT HAVE COURSES';
export const GET_STUDENT_PROGRESS_REPORT = '[STUDENT APP] GET STUDENT PROGRESS REPORT';

export function updateStudentLoaded(setting) {
    return {
        type: UPDATE_STUDENT_LOADED,
        payload: setting
    }
}

export function getStudentData(student_id) {
    return (dispatch) => {
        Promise.all([
            dispatch(getStudent(student_id)),
            dispatch(getStudentSchedule(student_id, new Date())),
            dispatch(getRelatedData(student_id)),
            dispatch(getEditInfo(student_id))
        ]).then(
            () => dispatch(updateStudentLoaded(true))
        )
    }
}

export function getEditInfo(student_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/student/get/edit_info/' + student_id)
            .then((response) => response.json())
            .then((studentData) => {
                dispatch({
                    type: GET_EDIT_INFO,
                    payload: studentData,
                });
            });
    }
}

export function getStudent(student_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/student/get/' + student_id)
            .then((response) => response.json())
            .then((studentData) => {
                dispatch({
                    type: GET_STUDENT,
                    payload: studentData,
                });
            });
    }
}

export function saveStudent(student, companies, auth_id) {
    const newStudent = { ...student, CreateAuthID: auth_id, LastEditAuthID: auth_id }
    return async (dispatch, getState) => {
        await fetch(server_connection + '/student/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student: newStudent, companies: companies })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getStudentList());
            });
    }
}

export function deleteStudent(student_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/student/delete',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ student_id: student_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(getStudentList());
            });
    }
}

export function getStudentList() {
    const auth_id = store.getState().auth.user.data.auth_id
    return (dispatch, getState) => {
        fetch(server_connection + '/student/list',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({ auth_id })
            })
            .then((response) => response.json())
            .then((responseData) => {
                dispatch({
                    type: GET_STUDENT_LIST,
                    payload: responseData,
                });
            });
    }
}

export function updateStudentForm(student_data) {
    return {
        type: UPDATE_STUDENT_FORM,
        payload: student_data
    }
}

export function getStudentSchedule(student_id, toggleDate) {
    return async (dispatch) => {
        return await fetch(server_connection + '/student/schedule/' + student_id + '/' + toggleDate)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_STUDENT_SCHEDULE,
                    payload: events
                })
            })
    }
}

export function getDayEvents(student_id, toggleDate) {
    return async (dispatch) => {
        return await fetch(server_connection + '/student/schedule/day_events/' + student_id + '/' + toggleDate)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_DAY_EVENTS,
                    payload: events
                })
            })
    }
}

export function getNextUnscheduledEvents(student_id, toggleDate) {
    return async (dispatch) => {
        return await fetch(server_connection + '/student/get_self_paced_events/' + student_id + '/' + toggleDate)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_NEXT_UNSCHEDULED_EVENTS,
                    payload: events
                })
            })
    }
}

export function getNextScheduledEvent(student_id, toggleDate) {
    return async (dispatch) => {
        return await fetch(server_connection + '/student/get_next_scheduled_event_dashboard/' + student_id + '/' + toggleDate)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_NEXT_SCHEDULED_EVENT,
                    payload: events
                })
            })
    }
}

export function getNextUnscheduledEventWidget(student_id, toggleDate) {
    return async (dispatch) => {
        return await fetch(server_connection + '/student/get_next_unscheduled_event_dashboard/' + student_id + '/' + toggleDate)
            .then((response) => response.json())
            .then((events) => {
                dispatch({
                    type: GET_NEXT_UNSCHEDULED_EVENT_WIDGET,
                    payload: events
                })
            })
    }
}

export function checkDoesStudentHaveCourses(student_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/student/does_student_have_courses/' + student_id)
            .then((response) => response.json())
            .then((bool) => {
                dispatch({
                    type: CHECK_DOES_STUDENT_HAVE_COURSES,
                    payload: bool
                })
            })
    }
}


export function getRelatedData(student_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/student/data/' + student_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_RELATED_DATA,
                    payload: data
                })
            })
    }
}

export function toggleCompany(company, action_type) {
    return {
        type: TOGGLE_COMPANY,
        payload: {company: company, action_type: action_type}
    }
}

export function getStudentCourses(student_id) {
    return async (dispatch) => {
        return await fetch(server_connection + '/student/courses/' + student_id)
            .then((response) => response.json())
            .then((data) => {
                dispatch({
                    type: GET_STUDENT_COURSES,
                    payload: data
                })
            })
    }
}

export function deactivateStudentAuth(auth_id, student_id) {
    return (dispatch, getState) => {
        fetch(server_connection + '/auth/deactivate/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(
                    {
                        type: DELETE_STUDENT,
                        payload: student_id
                    }
                ) 
            });
    }
}

export function getStudentProgressReport(student_id) {
    const auth_id = store.getState().auth.user.data.auth_id;
    return (dispatch, getState) => {
        fetch(server_connection + '/student/progress_report/' + student_id + '/' + auth_id)
            .then((response) => response.json())
            .then((responseData) => {
                dispatch(
                    {
                        type: GET_STUDENT_PROGRESS_REPORT,
                        payload: responseData
                    }
                ) 
            });
    }
}


// WEBPACK FOOTER //
// src/main/content/student/store/actions/student.actions.js